import globalAxios from "../GlobalAxios";

const getRpApi = async () => {
  try {
    const res = await globalAxios.get('/api/statistics/getrp');
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const tencentTrafficApi = async (params) => {
  try {
    // const res = await globalAxios.get('/api/statistics/tencentcdntraffic');
    const res = await globalAxios.get('/api/statistics/tencentcdntraffic-info', { params: params });
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const tencentTrafficDailyApi = async () => {
  try {
    const res = await globalAxios.get('/api/statistics/traffic_daily');
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const tencentTrafficMonthlyApi = async () => {
  try {
    const res = await globalAxios.get('/api/statistics/traffic_monthly');
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const encodingApi = async () => {
  try {
    const res = await globalAxios.get('/api/statistics/encoding');
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}


const storageApi = async () => {
  try {
    const res = await globalAxios.get('/api/statistics/s3');
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const originApi = async (metricParams) => {
  try {
    const res = await globalAxios.get('/api/statistics/tencentorigin', { params: metricParams });
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const cdnApi = async (metricParams) => {
  try {
    const res = await globalAxios.get('/api/statistics/tencentcdn', { params: metricParams });
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const encodingDatePickerApi = async (params) => {
  try {
    const res = await globalAxios.get('/api/statistics/encoding-info', { params: params });
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}




export default {
  getRpApi,
  tencentTrafficApi,
  tencentTrafficDailyApi,
  tencentTrafficMonthlyApi,
  storageApi,
  encodingApi,
  originApi,
  cdnApi,
  encodingDatePickerApi,
};